import {useIntl} from 'react-intl';
import {Ban} from 'lucide-react';
import type {DialerRefusal} from '../store/callSurfaceSlice';
import {dialerMessages as m} from './dialerMessages';
import {refusalReason} from './dialerRefusal';

/** Call restrictions refused the dialled number: no busy tone, the reason instead (boards DialerBlocked, DialerPriceBlocked). */
export const RefusalRow = ({refusal}: {refusal: DialerRefusal}) => {
    const intl = useIntl();
    const reason = refusalReason(refusal);
    return (
        <div role="alert" data-testid="dialer-refusal" className="flex gap-2.5 rounded-2xl bg-[var(--phq-call-danger-tint)] p-3">
            <Ban size={16} className="mt-0.5 shrink-0 text-[var(--phq-call-danger-ink)]" aria-hidden="true"/>
            <div className="flex flex-col gap-1">
                <p className="text-sm font-semibold text-[var(--phq-call-danger-ink)]">{intl.formatMessage(m.refusedTitle)}</p>
                <p className="text-[13px] leading-[18px] text-[var(--phq-call-ink-secondary)]">{intl.formatMessage(reason.message, reason.values)}</p>
            </div>
        </div>
    );
};
